import { v4 as uuid } from 'uuid';
import { IOpportunities } from '../models/service/service';
import { errorNames } from './constants';

/* eslint-disable */
export const replaceWithEnumValue = (
  enumConst: { [key: string]: string },
  array: string[]
): string[] => {
  const newArray: string[] = [];
  for (const key of array) {
    newArray.push(enumConst[key]);
  }
  return newArray;
};

export const convertTime = (time: string): string => {
  const date = new Date(time);
  const now = new Date();
  date.setHours(now.getHours());
  date.setUTCHours(date.getUTCHours() + 6);
  date.setMinutes(now.getMinutes());
  date.setSeconds(now.getSeconds());
  date.setMilliseconds(now.getMilliseconds());
  const options = { timeZone: 'Australia/Canberra' };
  const dateString = date.toLocaleString('en-US', options);

  const isoString = new Date(dateString).toISOString();
  return isoString;
}

export function convertDataURIToImageURL(dataURI: string): string {
  const [type, data] = dataURI.split(";base64,");
  const blob = new Blob([atob(data)], { type });
  const imageURL = URL.createObjectURL(blob);
  return imageURL;
}

export const convertedArray = (originalArray: string[]): string[] => {
  return originalArray.map((item) => {
    return item.toUpperCase().replace(/\s/g, '_');
  });
}

export const capitalizeFirstLetter = (str: string) => {
  str = str.toLowerCase().replace(/_/g, ' ');
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const toCapitalizeCase = (str?: string): string => {
  if (str) {
    const res = str.replace(/_/g, ' ').toLowerCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  return '';
};

export const convertedArrayReverse = (words: string[]) => {
  return words.map((item) => {
    const words = item.split('_');
    const capitalizedWords = words.map((word) => {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    });
    return capitalizedWords.join(' ');
  });
}

export const convertedArrayReverseWithSpace = (words: string[]) => {
  let counter = 0;
  return words.map((item) => {
    const words = item.split('_');
    const capitalizedWords = words.map((word) => {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    });
    counter += 1;
    if (counter > 1) {
      return ' ' + capitalizedWords.join(' ');
    }
    return capitalizedWords.join(' ');
  });
}

export const openQualification = (array: any): string[] => {
  return array.map((item: { content: string }) => {
    const result = [];
    result.push(item.content);
    return result;
  })
}

export const generateFilename = (extension?: string) => {
  const uuidStr = uuid();
  return `${uuidStr}.${extension || ''}`;
};

export const getAlphabetSection = (letter: string) => {
  const alphabet = "abcdefghijklmnopqrstuvwxyz";
  const sectionSize = Math.ceil(alphabet.length / 4);
  const letterIndex = alphabet.indexOf(letter.toLowerCase());

  if (letterIndex === -1) {
    throw new Error("Invalid input: not a letter.");
  }

  if (letterIndex < sectionSize) {
    return 1;
  } else if (letterIndex < sectionSize * 2) {
    return 2;
  } else if (letterIndex < sectionSize * 3) {
    return 3;
  } else {
    return 4;
  }
};

export const isExpiredOpp = (endDate: string, frequency: string) => {
  if (frequency === "ONE_DAY") {
    const endDateTime = new Date(endDate).getTime();
    const currentDateTime = new Date().getTime();
  
    return currentDateTime > endDateTime;
  }
  return false;
};

export const isActiveOpp = ({ endDate, frequency }: IOpportunities) => {
  const endDateTime = new Date(endDate).valueOf();
  const currentDateTime = new Date().valueOf();
  return (currentDateTime < endDateTime) || (!!frequency.find((fr) => fr.toLowerCase().includes('every')));
};

export const checkString = (text: string) => {
  if (!/[A-Z]/.test(text)) {
    return errorNames.invalidPasswordLetter;
  }
  if (!/\d/.test(text)) {
    return errorNames.invalidPasswordDigit;
  }
  if (!/[a-z]/.test(text)) {
    return errorNames.invalidPasswordLowercase;
  }
  return '';
};